import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckIcon from '@mui/icons-material/Check';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';

const DataTrust = () => {
	const { t } = useTranslation('landing', { keyPrefix: 'sections.dataTrust' });

	return (
		<Box
			id="trust"
			component="section"
			sx={{
				py: 5,
				bgcolor: 'background.secondary',
				overflow: 'hidden'
			}}
		>
			<Container maxWidth="lg">
				<Typography variant="h3" align="center" gutterBottom>
					{t('header')}
				</Typography>

				<Box
					sx={{
						display: 'grid',
						gap: 4,
						mt: 5,
						gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }
					}}
				>
					<Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
						<SecurityIcon color="primary" fontSize="large" sx={{ mb: 1.5 }} />
						<Typography variant="h6"> {t('security.header')}</Typography>
						<Typography variant="body2" color="textSecondary">
							{t('security.description')}
						</Typography>
					</Paper>

					<Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
						<CloudUploadIcon
							color="success"
							fontSize="large"
							sx={{ mb: 1.5 }}
						/>
						<Typography variant="h6">{t('cloud.header')}</Typography>
						<Typography variant="body2" color="textSecondary">
							{t('cloud.description')}
						</Typography>
					</Paper>

					<Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
						<SpeedIcon color="error" fontSize="large" sx={{ mb: 1.5 }} />
						<Typography variant="h6">{t('cost.header')}</Typography>
						<Typography variant="body2" color="textSecondary">
							{t('cost.description')}
						</Typography>
					</Paper>

					<Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
						<CheckIcon color="success" fontSize="large" sx={{ mb: 1.5 }} />
						<Typography variant="h6">{t('sharing.header')}</Typography>
						<Typography variant="body2" color="textSecondary">
							{t('sharing.description')}
						</Typography>
					</Paper>
				</Box>
			</Container>
		</Box>
	);
};

export default DataTrust;
